import { Text } from 'blaze-ui/Text/Text'
import Styles from './AutopilotSidebar.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { SupportChat } from 'components/FirstTimeExperienceModal/components/SupportChat/SupportChat'

interface Section {
  heading: string
  text: string | JSX.Element
}

export const AutopilotSidebar = ({
  showSupportButton = true,
  sections,
}: {
  showSupportButton?: boolean
  sections: Section[]
}) => {
  return (
    <div className={Styles.container}>
      <div className={Styles.content}>
        {sections.map((section) => (
          <div className={Styles.text} key={section.heading} data-autopilot-sidebar-section={section.heading}>
            <Heading level={5}>{section.heading}</Heading>
            <Text variant="placeholder" color="var(--dark-80)">
              {section.text}
            </Text>
          </div>
        ))}
        {showSupportButton && <SupportChat />}
      </div>
    </div>
  )
}
